import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "machinePointRatioPackage";

const url = "/api/machines/MachinePointRatioPackage";

export const machinePointRatioPackageLookupConfig = simpleLookupConfig(
  vsLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "Point Ratio Package",
    url,
  }
);
